<div class="filter-bar">
  <div class="action-buttons">

    <input #qrFilesInput type="file" multiple hidden />


  </div>

</div>


<app-base-list-page #baseListPage [headersList]="headerList" [multiSelectFilterLists]="multiSelectFilterLists"
  [checkboxes]="checkboxes" (rowClick)="equipmentClicked($event)" [extraBurgerMenuOptions]="extraBurgerOptions">
</app-base-list-page>